// Arabic strings for the redesigned Customers analytics workspace
// (components/Reports/CustomersWorkspace). Kept separate from the legacy
// Reports/Customers module so the old report wording is untouched.
const trans = {
  // Tabs + page chrome
  Surveys: "الاستبيانات",
  "Registered users": "المستخدمون المسجّلون",
  "Customer analytics across behavior, customer records, registered users, feedback and surveys.":
    "تحليلات العملاء عبر السلوك وسجلات العملاء والمستخدمين المسجّلين والملاحظات والاستبيانات.",
  Live: "مباشر",
  rows: "صفوف",
  // Pulse export (scorecard) column headers
  Metric: "المقياس",
  Value: "القيمة",
  Change: "التغيّر",

  // Pulse KPIs + hints
  "Total customers": "إجمالي العملاء",
  "Customers who ordered in the period": "العملاء الذين طلبوا خلال الفترة",
  "Repeat rate": "معدل التكرار",
  "Share who ordered more than once": "نسبة من طلبوا أكثر من مرة",
  "Avg spend": "متوسط الإنفاق",
  "Average customer spend": "متوسط إنفاق العميل",
  "Revenue divided by customers": "الإيرادات مقسومة على عدد العملاء",
  "New customers": "عملاء جدد",
  "First ordered in this period": "طلبوا لأول مرة في هذه الفترة",
  "Returning customers": "العملاء العائدون",
  Recurring: "متكرر",
  "Recurring AOV": "متوسط طلب المتكررين",
  "New AOV": "متوسط طلب الجدد",
  "New vs Recurring": "الجدد مقابل المتكررين",
  "Revenue: new vs returning": "الإيرادات: الجدد مقابل العائدين",
  "First-order customers compared with repeat purchasers":
    "عملاء الطلب الأول مقارنةً بالعملاء المتكررين",
  "Customer behavior based on the selected filters. Cohorts use a bounded per-month sample; favourites and menu mix use a bounded order sample for speed.":
    "سلوك العملاء بناءً على عوامل التصفية المحددة. تستخدم المجموعات عيّنة شهرية محدودة؛ وتستخدم المفضّلة وتنوّع القائمة عيّنة طلبات محدودة لتحسين السرعة.",

  // Churn & win-back
  "Churn & win-back": "التسرّب واستعادة العملاء",
  "Customers slipping away": "عملاء على وشك المغادرة",
  "Total spend from those customers": "إجمالي إنفاق هؤلاء العملاء",
  "of customers": "من العملاء",
  "at stake": "معرّضة للخطر",
  avg: "متوسط",
  "days since last order": "يوم منذ آخر طلب",

  // Segments (RFM)
  "Segments (RFM)": "الشرائح (RFM)",
  "RFM customer segments from the selected filters. The detailed customer table stays in Customer List.":
    "شرائح العملاء (RFM) بناءً على عوامل التصفية المحددة. يبقى جدول العملاء التفصيلي في قائمة العملاء.",
  "Click a segment to view those customers": "اضغط على شريحة لعرض عملائها",
  "Share of customers by RFM segment": "حصة العملاء حسب شريحة RFM",
  "Value by segment": "القيمة حسب الشريحة",
  "Spend contribution across segments": "مساهمة الإنفاق عبر الشرائح",
  "Segmented customers": "العملاء المصنّفون",
  "Segmented spend": "الإنفاق المصنّف",
  "Highest value segment": "الشريحة الأعلى قيمة",
  "Largest segment": "أكبر شريحة",
  Size: "الحجم",
  // RFM segment descriptions (backend)
  "Buy and spend more than others and purchased recently.":
    "يشترون وينفقون أكثر من غيرهم واشتروا مؤخرًا.",
  "Purchase often and spend a healthy amount compared with other customers.":
    "يشترون كثيرًا وينفقون مبلغًا جيدًا مقارنةً بالعملاء الآخرين.",
  "Do not purchase frequently, but spend more than average when they do.":
    "لا يشترون بكثرة، لكنهم ينفقون أكثر من المتوسط عند الشراء.",
  "Purchase less often and spend less than most customers.":
    "يشترون بمعدل أقل وينفقون أقل من معظم العملاء.",
  "Spent well before, but have become less recent.":
    "أنفقوا جيدًا سابقًا، لكن نشاطهم أصبح أقل حداثة.",
  "Older customers with low recent activity.": "عملاء أقدم بنشاط حديث منخفض.",
  "Recently active customers in the selected period.": "عملاء نشطون مؤخرًا خلال الفترة المحددة.",
  "Customers that do not match a specific RFM segment.": "عملاء لا يطابقون شريحة RFM محددة.",
  // RFM segment actions (CUSTOMERS_SEGMENT_ACTIONS)
  "Reward & protect": "كافئهم واحمِهم",
  "Keep engaged": "حافظ على تفاعلهم",
  Upsell: "بيع إضافي",
  "Volume offers": "عروض الكميات",
  "Nurture to 2nd order": "ادفعهم نحو الطلب الثاني",
  "Re-engage": "أعد التفاعل معهم",
  "Win back now": "استعدهم الآن",

  // Cohort retention
  Cohort: "المجموعة",
  "Cohort Retention": "احتفاظ المجموعات",
  "Retention by cohort": "الاحتفاظ حسب المجموعة",
  "Rows are first purchase month; darker cells retained more customers":
    "الصفوف تمثّل شهر الشراء الأول؛ الخلايا الأغمق احتفظت بعملاء أكثر",
  "% reordering, months after first order": "% إعادة الطلب، بعد أشهر من الطلب الأول",

  // Geography
  "Where customers are": "أين يقع العملاء",
  "Customer distribution": "توزيع العملاء",
  "Top areas": "أفضل المناطق",

  // Top customers / favourites / menu mix / distribution
  "Top customers": "أفضل العملاء",
  "Top Customers": "أفضل العملاء",
  "Ranked by spend with dominant menu categories": "مرتّبة حسب الإنفاق مع الفئات الأكثر طلبًا",
  Favourites: "المفضّلة",
  "Menu mix": "تنوّع القائمة",
  "By channel": "حسب القناة",
  "By spend": "حسب الإنفاق",
  "Customers by order count": "العملاء حسب عدد الطلبات",
  "10x+": "+10 مرات",

  // Customer list columns
  "Total spend": "إجمالي الإنفاق",
  "Last order date": "تاريخ آخر طلب",
  "Days since last order": "أيام منذ آخر طلب",
  "Purchase Frequency": "تكرار الشراء",
  "Open customer profile": "فتح ملف العميل",
  "Customer profile": "ملف العميل",
  "Editing still uses the legacy customer profile form.": "لا يزال التعديل يستخدم نموذج ملف العميل القديم.",

  // Feedback
  "Customer feedback and product feedback. Click a row to inspect the comment and website visibility.":
    "ملاحظات العملاء وملاحظات المنتجات. اضغط على صف لمعاينة التعليق وظهوره على الموقع.",
  "Positive responses": "ردود إيجابية",
  "Low ratings": "تقييمات منخفضة",
  Responses: "الردود",
  "Hide from website": "إخفاء من الموقع",
  Visible: "ظاهر",
  Hidden: "مخفي",

  // Surveys
  "Create, share and inspect customer survey responses.": "أنشئ استبيانات العملاء وشاركها وراجع ردودها.",
  "Create Survey": "إنشاء استبيان",
  "Send survey by SMS": "إرسال الاستبيان عبر رسالة نصية",
  "Survey responses": "ردود الاستبيان",
  "Survey link copied successfully": "تم نسخ رابط الاستبيان بنجاح",
  "Customer's Email": "بريد العميل الإلكتروني",
  "QR code": "رمز QR",
};

export default trans;
